import GrossProfitReportPage from 'pages/GrossProfitReport/GrossProfitReportPage';

const GrossProfitReportRoutes = [
  {
    path: '/gross-profit',
    exact: true,
    name: 'Báo cáo lãi gộp',
    function: 'GROSS_PROFIT_REPORT_VIEW',
    component: GrossProfitReportPage,
  },
];

export default GrossProfitReportRoutes;
